import { Box, Text } from "@chakra-ui/react";

export function BorderedTag({ text }: { text: string }) {
  return (
    <Box
      bg="transparent"
      borderRadius="full"
      border="1px solid"
      borderColor="blaze.300"
      px="8px"
    >
      <Text variant="monospaceTime" letterSpacing="0.5px" color="dune.dune">
        {text}
      </Text>
    </Box>
  );
}
